import { useEffect, useState } from "react";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navItems = [
    { href: "#occasions", label: "Occasions" },
    { href: "#rentals", label: "Rentals" },
    { href: "#reviews", label: "Reviews" },
    { href: "#book", label: "Book" },
    { href: "#feed", label: "Feed" },
  ];

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-white/85 backdrop-blur-md border-b border-black/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1480px] mx-auto px-6 md:px-12 py-5 md:py-6 flex items-center justify-between">
        {/* Left: word mark */}
        <a
          href="#top"
          data-testid="header-brand"
          className="font-display text-[15px] md:text-[17px] tracking-[0.02em] leading-none"
        >
          <span className="italic mr-1 text-[11px] md:text-[12px] align-top">The</span>
          Prismatics Co.
        </a>

        {/* Center: nav */}
        <nav className="hidden md:flex items-center gap-8 lg:gap-10">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={`nav-link-${item.label.toLowerCase()}`}
              className="label-micro link-underline hover:opacity-100 opacity-80"
            >
              {item.label}
            </a>
          ))}
        </nav>

        {/* Right: CTA — stands out as solid pill */}
        <a
          href="#contact-cta"
          data-testid="header-cta-book"
          className="hidden md:inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-black text-white font-body text-[10px] uppercase tracking-[0.24em] transition-all hover:tracking-[0.3em] hover:bg-black/85"
        >
          <span className="inline-block w-1.5 h-1.5 rounded-full bg-white animate-pulse" />
          <span>Contact us</span>
          <span aria-hidden>→</span>
        </a>

        {/* Mobile toggle */}
        <button
          type="button"
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
          onClick={() => setOpen(!open)}
          className="md:hidden flex flex-col gap-[5px] p-2 -mr-2"
        >
          <span className={`block w-6 h-px bg-black transition-transform ${open ? "translate-y-[6px] rotate-45" : ""}`} />
          <span className={`block w-6 h-px bg-black transition-opacity ${open ? "opacity-0" : ""}`} />
          <span className={`block w-6 h-px bg-black transition-transform ${open ? "-translate-y-[6px] -rotate-45" : ""}`} />
        </button>
      </div>

      {/* Mobile panel */}
      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden border-t border-black/10 bg-white px-6 py-8 flex flex-col gap-6"
        >
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-link-${item.label.toLowerCase()}`}
              className="font-display text-3xl"
            >
              {item.label}
            </a>
          ))}
          <a
            href="#terms"
            onClick={() => setOpen(false)}
            data-testid="mobile-nav-link-terms"
            className="font-display text-3xl"
          >
            Terms
          </a>
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            data-testid="mobile-nav-link-contact"
            className="label-micro mt-4"
          >
            Contact us →
          </a>
        </div>
      )}
    </header>
  );
};
